import { addCalendarDays } from './businessDay'

/** Parse yyyy-MM-dd into UTC date parts. */
function parseBusinessDate(dateStr: string): { y: number; m: number; d: number } {
  const [y, m, d] = dateStr.split('-').map(Number)
  return { y: y || 1970, m: m || 1, d: d || 1 }
}

/**
 * UTC offset in ms at a given instant for an IANA timezone (handles DST).
 * local = utc + offsetMs
 */
function timezoneOffsetMsAt(instant: Date, timezone: string): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).formatToParts(instant)
  const get = (type: string) =>
    Number(parts.find((p) => p.type === type)?.value ?? '0')
  const asUtc = Date.UTC(
    get('year'),
    get('month') - 1,
    get('day'),
    get('hour'),
    get('minute'),
    get('second'),
  )
  return asUtc - instant.getTime()
}

/** Instant when a calendar day starts in the given timezone (inclusive). */
function startOfBusinessDayUtc(businessDate: string, timezone: string): Date {
  const { y, m, d } = parseBusinessDate(businessDate)
  const guessUtc = Date.UTC(y, m - 1, d, 0, 0, 0)
  const offset = timezoneOffsetMsAt(new Date(guessUtc), timezone)
  return new Date(guessUtc - offset)
}

/** UTC ISO bounds [startIso, endIso) for a business calendar day in place timezone. */
export function businessDayUtcBounds(
  businessDate: string,
  timezone: string,
): { startIso: string; endIso: string } {
  const start = startOfBusinessDayUtc(businessDate, timezone)
  const nextDate = addCalendarDays(businessDate, 1)
  const end = startOfBusinessDayUtc(nextDate, timezone)
  return { startIso: start.toISOString(), endIso: end.toISOString() }
}
